export const ThirdPartyCostType = ({
    Other: {
        id: 0,
        label: 'Other'
    },
    Data: {
        id: 1,
        label: 'Data'
    },
    AdVerification: {
        id: 2,
        label: 'Ad Verification'
    },
    AdServing: {
        id: 3,
        label: 'Ad Serving'
    },
    Markup: {
        id: 4,
        label: 'Markup'
    },
    ObaCompliance: {
        id: 5,
        label: 'Privacy Compliance'
    },
    VideoAdServing: {
        id: 6,
        label: 'Video Ad Serving'
    },
    TurnDco: {
        id: 7,
        label: 'Amobee DCO'
    },
    Poi: {
        id: 8,
        label: 'Location Data'
    },
    /* deprecated
    TurnDisplayViewabilityGoalType: {
        id: 9,
        label: 'Amobee Viewability Goal Type'
    },
    */
    ODCInFlightDSP: {
        id: 10,
        label: 'ODC In-Flight DSP'
    },
    /* 
    OfflineData: {
        id: 11,
        label: 'Offline Data'
    },
    OfflineDataForIRIDispMobile: {
        id: 12,
        label: 'Offline Data For IRI - Display & Mobile'
    },
    OfflineDataForIRIVideo: {
        id: 13,
        label: 'Offline Data For IRI - Video'
    },
    OfflineDataForIRIDAudio: {
        id: 14,
        label: 'IRI - Offline Data - Audio'
    }*/
});